module.exports = __webpack_public_path__ + "static/media/Item_Armor_E_00_Lv1_C.17c03679.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Equipment/Vest/Item_Armor_E_00_Lv1_C.png
// module id = 373
// module chunks = 0